import React from 'react';
import DocumentTemplateSettings from '../components/documents/DocumentTemplateSettings';

export default function QuotationSettings() {
  return (
    <DocumentTemplateSettings
      title="Quotation Templates"
      description="Build scoped quotation documents using the unified document engine. Kitchen execution uses the Order Kitchen Copy and KOT, so new Work Order templates are no longer exposed."
      documentTypes={[{ value: 'QUOTATION', label: 'Quotation' }]}
    />
  );
}
